{
  "filters": {
    "filters": {
      "sourceAgg": {
        "field": "source_agg",
        "label": "Source",
        "type": "multi",
        "source": "api",
        "column": "source_agg",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "parentCustomer": {
        "field": "parent_customer",
        "label": "Customer",
        "type": "multi",
        "source": "api",
        "column": "parent_customer",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "product": {
        "field": "product",
        "label": "Product",
        "type": "multi",
        "source": "api",
        "column": "product",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "salesChannelAgg": {
        "field": "sales_channel_agg",
        "label": "Sales Channel",
        "type": "multi",
        "source": "api",
        "column": "sales_channel_agg",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "orderQtyBucketDesc": {
        "field": "order_qty_bucket_desc",
        "label": "Order Size",
        "type": "multi",
        "source": "api",
        "column": "order_qty_bucket_desc",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "customerRevBucketDesc": {
        "field": "customer_rev_bucket_desc",
        "label": "Customer Size",
        "type": "multi",
        "source": "api",
        "column": "customer_rev_bucket_desc",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "region": {
        "field": "region",
        "label": "Region",
        "type": "multi",
        "source": "api",
        "column": "region",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "productLineDescription": {
        "field": "product_line_description",
        "label": "Product Line",
        "type": "multi",
        "source": "api",
        "column": "product_line_description",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "family": {
        "field": "family",
        "label": "Product Family",
        "type": "multi",
        "source": "api",
        "column": "family",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "forecastcluster": {
        "field": "forecastcluster",
        "label": "Forecast Cluster",
        "type": "multi",
        "source": "api",
        "column": "forecastcluster",
        "fetchDistinct": true,
        "orderDirection": "asc"
      },
      "itemgroup": {
        "field": "itemgroup",
        "label": "Item Group",
        "type": "multi",
        "source": "api",
        "column": "itemgroup",
        "fetchDistinct": true,
        "orderDirection": "asc"
      }
    }
  },
  "pages": {
    "home": {
      "features": {
        "metrics": {
          "registry": {
            "Average Margin": {
              "id": "average_margin",
              "display": {
                "label": "Average Margin",
                "showPercentageChange": true,
                "type": "percentage",
                "unit": "pts",
                "isPercentagePointMetric": true
              }
            },
            "Total Revenue": {
              "id": "total_revenue",
              "display": {
                "label": "Total Revenue",
                "showPercentageChange": true,
                "type": "revenue"
              }
            },
            "Total Transactions": {
              "id": "total_transactions",
              "display": {
                "label": "Total Transactions",
                "showPercentageChange": true,
                "type": "quantity"
              }
            },
            "Average Price": {
              "id": "average_unit_price",
              "display": {
                "label": "Average Price",
                "showPercentageChange": true,
                "type": "price"
              }
            }
          },
          "selection": {
            "defaultMetricIds": [
              "average_margin",
              "total_revenue",
              "total_transactions",
              "average_unit_price"
            ],
            "allAvailableMetricIds": [
              "average_margin",
              "total_revenue",
              "total_transactions",
              "average_unit_price"
            ],
            "persistSelection": false,
            "ordering": [
              "average_margin",
              "total_revenue",
              "total_transactions",
              "average_unit_price"
            ]
          }
        }
      }
    },
    "sales-rep-performance": {
      "features": {
        "metrics": {
          "registry": {
            "Profit Per Rep": {
              "id": "profit_per_rep",
              "display": {
                "label": "Profit Per Rep",
                "showPercentageChange": true,
                "type": "revenue"
              }
            },
            "Revenue Per Rep": {
              "id": "revenue_per_rep",
              "display": {
                "label": "Revenue Per Rep",
                "showPercentageChange": true,
                "type": "revenue"
              }
            },
            "Number Of New Deals": {
              "id": "total_transactions",
              "display": {
                "label": "Number Of New Deals",
                "showPercentageChange": true,
                "type": "quantity"
              }
            },
            "Margin": {
              "id": "average_margin",
              "display": {
                "label": "Margin",
                "showPercentageChange": true,
                "type": "percentage",
                "unit": "pts",
                "isPercentagePointMetric": true
              }
            }
          },
          "selection": {
            "defaultMetricIds": [
              "total_transactions",
              "revenue_per_rep",
              "profit_per_rep",
              "average_margin"
            ],
            "allAvailableMetricIds": [
              "total_transactions",
              "revenue_per_rep",
              "profit_per_rep",
              "average_margin"
            ],
            "persistSelection": false,
            "ordering": [
              "average_margin",
              "revenue_per_rep",
              "profit_per_rep",
              "total_transactions"
            ]
          }
        },
        "tables": {
          "registry": {
            "sales-reps": {
              "id": "sales-reps",
              "label": "Sales Rep Performance",
              "defaultSortField": "revenue",
              "defaultSortOrder": -1,
              "pageSize": 15,
              "chunkSize": 50,
              "columns": [
                {
                  "field": "repName",
                  "header": "Sales Rep",
                  "type": "text",
                  "sortable": true,
                  "clickable": true,
                  "avatar": true,
                  "align": "left"
                },
                {
                  "field": "revenue",
                  "header": "Revenue",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "margin",
                  "header": "Margin",
                  "type": "percent",
                  "sortable": true
                },
                {
                  "field": "marginAmount",
                  "header": "Profit",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "averageDealSize",
                  "header": "Avg. Deal Size",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true
                },
                {
                  "field": "numberOfTransactions",
                  "header": "Transactions",
                  "type": "integer",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true
                },
                {
                  "field": "categories",
                  "header": "Categories",
                  "type": "integer",
                  "sortable": true
                },
                {
                  "field": "productsSold",
                  "header": "Products Sold",
                  "type": "integer",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "volume",
                  "header": "Volume",
                  "type": "integer",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "numberOfCustomers",
                  "header": "Number of Customers",
                  "type": "integer",
                  "sortable": true,
                  "headerMaxWidth": "6.5rem"
                },
                {
                  "field": "priceOverVolume",
                  "header": "Average Price",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "6.5rem",
                  "abbreviate": true
                }
              ],
              "fieldMappings": [
                {
                  "backend": "rep_name",
                  "ui": "repName",
                  "dbFieldName": "salesperson"
                },
                {
                  "backend": "total_revenue",
                  "ui": "revenue",
                  "transform": "number"
                },
                {
                  "backend": "margin_percent",
                  "ui": "margin",
                  "transform": "number"
                },
                {
                  "backend": "total_margin_dollars",
                  "ui": "marginAmount",
                  "transform": "number"
                },
                {
                  "backend": "avg_deal_size",
                  "ui": "averageDealSize",
                  "transform": "number"
                },
                {
                  "backend": "num_transactions",
                  "ui": "numberOfTransactions"
                },
                {
                  "backend": "num_categories",
                  "ui": "categories"
                },
                {
                  "backend": "num_products_sold",
                  "ui": "productsSold"
                },
                {
                  "backend": "total_volume",
                  "ui": "volume",
                  "transform": "number"
                },
                {
                  "backend": "number_of_customers",
                  "ui": "numberOfCustomers"
                },
                {
                  "backend": "price_over_volume",
                  "ui": "priceOverVolume",
                  "transform": "number"
                }
              ]
            }
          }
        }
      }
    },
    "customer-performance": {
      "features": {
        "metrics": {
          "registry": {
            "Profit Per Customer": {
              "id": "profit_per_customer",
              "display": {
                "label": "Profit Per Customer",
                "showPercentageChange": true,
                "type": "revenue"
              }
            },
            "Revenue Per Customer": {
              "id": "revenue_per_customer",
              "display": {
                "label": "Revenue Per Customer",
                "showPercentageChange": true,
                "type": "revenue"
              }
            },
            "Number Of Active Customers": {
              "id": "total_active_customers",
              "display": {
                "label": "Number Of Active Customers",
                "showPercentageChange": true,
                "type": "quantity"
              }
            },
            "Margin": {
              "id": "average_margin",
              "display": {
                "label": "Margin",
                "showPercentageChange": true,
                "type": "percentage",
                "unit": "pts",
                "isPercentagePointMetric": true
              }
            }
          },
          "selection": {
            "defaultMetricIds": [
              "total_active_customers",
              "revenue_per_customer",
              "profit_per_customer",
              "average_margin"
            ],
            "allAvailableMetricIds": [
              "total_active_customers",
              "revenue_per_customer",
              "profit_per_customer",
              "average_margin"
            ],
            "persistSelection": false,
            "ordering": [
              "average_margin",
              "revenue_per_customer",
              "profit_per_customer",
              "total_active_customers"
            ]
          }
        },
        "tables": {
          "registry": {
            "customer-performance": {
              "id": "customer-performance",
              "label": "Customer Performance",
              "defaultSortField": "revenue",
              "defaultSortOrder": -1,
              "pageSize": 15,
              "chunkSize": 50,
              "columns": [
                {
                  "field": "customerName",
                  "header": "Customer Name",
                  "type": "text",
                  "sortable": true,
                  "clickable": true,
                  "avatar": true,
                  "align": "left"
                },
                {
                  "field": "revenue",
                  "header": "Revenue",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "margin",
                  "header": "Margin",
                  "type": "percent",
                  "sortable": true
                },
                {
                  "field": "marginAmount",
                  "header": "Profit",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "averageDealSize",
                  "header": "Avg. Deal Size",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "6.5rem",
                  "abbreviate": true
                },
                {
                  "field": "numberOfTransactions",
                  "header": "Transactions",
                  "type": "integer",
                  "sortable": true,
                  "headerMaxWidth": "6.5rem",
                  "abbreviate": true
                },
                {
                  "field": "categories",
                  "header": "Categories",
                  "type": "integer",
                  "sortable": true
                },
                {
                  "field": "productsSold",
                  "header": "Products Sold",
                  "type": "integer",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "volume",
                  "header": "Volume",
                  "type": "integer",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "priceOverVolume",
                  "header": "Average Price",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "6.5rem",
                  "abbreviate": true
                }
              ],
              "fieldMappings": [
                {
                  "backend": "customer_name",
                  "ui": "customerName"
                },
                {
                  "backend": "total_revenue",
                  "ui": "revenue",
                  "transform": "number"
                },
                {
                  "backend": "margin_percent",
                  "ui": "margin",
                  "transform": "number"
                },
                {
                  "backend": "total_margin_dollars",
                  "ui": "marginAmount",
                  "transform": "number"
                },
                {
                  "backend": "avg_deal_size",
                  "ui": "averageDealSize",
                  "transform": "number"
                },
                {
                  "backend": "num_transactions",
                  "ui": "numberOfTransactions"
                },
                {
                  "backend": "num_categories",
                  "ui": "categories"
                },
                {
                  "backend": "num_products_sold",
                  "ui": "productsSold"
                },
                {
                  "backend": "total_volume",
                  "ui": "volume",
                  "transform": "number"
                },
                {
                  "backend": "price_over_volume",
                  "ui": "priceOverVolume",
                  "transform": "number"
                }
              ]
            }
          }
        }
      }
    },
    "product-performance": {
      "features": {
        "metrics": {
          "registry": {
            "Margin": {
              "id": "average_margin",
              "display": {
                "label": "Margin",
                "showPercentageChange": true,
                "type": "percentage",
                "unit": "pts",
                "isPercentagePointMetric": true
              }
            },
            "Products Growing": {
              "id": "products_growing",
              "display": {
                "label": "Products Growing",
                "showPercentageChange": true,
                "type": "percentage"
              }
            },
            "Avg Customer Penetration": {
              "id": "average_customers_per_product",
              "display": {
                "label": "Avg. Customer Penetration",
                "showPercentageChange": true,
                "type": "quantity"
              }
            },
            "Products In Decline": {
              "id": "products_decline",
              "display": {
                "label": "Products In Decline",
                "showPercentageChange": true,
                "type": "percentage"
              }
            }
          },
          "selection": {
            "defaultMetricIds": [
              "average_margin",
              "products_growing",
              "average_customers_per_product",
              "products_decline"
            ],
            "allAvailableMetricIds": [
              "average_margin",
              "products_growing",
              "average_customers_per_product",
              "products_decline"
            ],
            "persistSelection": false,
            "ordering": [
              "average_margin",
              "products_growing",
              "average_customers_per_product",
              "products_decline"
            ]
          }
        },
        "tables": {
          "registry": {
            "product-performance": {
              "id": "product-performance",
              "label": "Product Performance",
              "defaultSortField": "revenue",
              "defaultSortOrder": -1,
              "pageSize": 15,
              "chunkSize": 50,
              "columns": [
                {
                  "field": "product",
                  "header": "Product",
                  "type": "text",
                  "sortable": true,
                  "clickable": true,
                  "avatar": true,
                  "avatarType": "icon",
                  "avatarIcon": "pi pi-building",
                  "align": "left",
                  "minWidth": "200px"
                },
                {
                  "field": "revenue",
                  "header": "Revenue",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "margin",
                  "header": "Margin",
                  "type": "percent",
                  "sortable": true
                },
                {
                  "field": "marginAmount",
                  "header": "Profit",
                  "type": "currency",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "averageDealSize",
                  "header": "Avg. Deal Size",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true
                },
                {
                  "field": "numberOfTransactions",
                  "header": "Transactions",
                  "type": "integer",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true
                },
                {
                  "field": "volume",
                  "header": "Volume",
                  "type": "integer",
                  "sortable": true,
                  "abbreviate": true
                },
                {
                  "field": "customerCount",
                  "header": "Number of Customers",
                  "type": "integer",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true
                },
                {
                  "field": "averagePrice",
                  "header": "Average Price",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true
                },
                {
                  "field": "averageCost",
                  "header": "Avg. Cost",
                  "type": "currency",
                  "sortable": true,
                  "headerMaxWidth": "12rem",
                  "abbreviate": true
                }
              ],
              "fieldMappings": [
                {
                  "backend": "product",
                  "ui": "product"
                },
                {
                  "backend": "total_revenue",
                  "ui": "revenue",
                  "transform": "number"
                },
                {
                  "backend": "margin_percent",
                  "ui": "margin",
                  "transform": "number"
                },
                {
                  "backend": "total_margin_dollars",
                  "ui": "marginAmount",
                  "transform": "number"
                },
                {
                  "backend": "avg_deal_size",
                  "ui": "averageDealSize",
                  "transform": "number"
                },
                {
                  "backend": "num_transactions",
                  "ui": "numberOfTransactions"
                },
                {
                  "backend": "customer_count",
                  "ui": "customerCount"
                },
                {
                  "backend": "total_volume",
                  "ui": "volume",
                  "transform": "number"
                },
                {
                  "backend": "avg_price",
                  "ui": "averagePrice",
                  "transform": "number"
                },
                {
                  "backend": "avg_cost",
                  "ui": "averageCost",
                  "transform": "number"
                }
              ]
            }
          }
        }
      }
    },
    "scorecard": {
      "features": {
        "businessSummary": {
          "kpis": [
            {
              "cardId": "revenue",
              "label": "Revenue",
              "type": "revenue"
            },
            {
              "cardId": "margin",
              "label": "Gross Margin",
              "type": "percentage",
              "isPercentagePointMetric": true
            },
            {
              "cardId": "customer_count",
              "label": "Customers",
              "type": "quantity"
            },
            {
              "cardId": "product_count",
              "label": "Unique SKUs",
              "type": "quantity"
            }
          ],
          "combinedTables": [
            {
              "id": "business_metrics_breakdown",
              "titlePrefix": "Business Metrics by",
              "subtitle": "Performance breakdown across volume, revenue, margin, and profit",
              "dimensions": [
                {
                  "cardId": "revenue_by_end_user_segment",
                  "dimensionLabel": "Customer Segment"
                },
                {
                  "cardId": "revenue_by_segment",
                  "dimensionLabel": "Major Customer Group",
                  "abcdLabel": "Customer Size (ABCD)"
                },
                {
                  "cardId": "revenue_by_top_product",
                  "dimensionLabel": "Major Product",
                  "abcdLabel": "Product Size (ABCD)",
                  "avatarIcon": "pi pi-box"
                }
              ]
            }
          ],
          "bottomKpis": [
            {
              "cardId": "top_customer_concentration",
              "label": "Top-20% Customer Concentration",
              "type": "percentage",
              "isPercentagePointMetric": true
            },
            {
              "cardId": "top_product_concentration",
              "label": "Top-20% Product Concentration",
              "type": "percentage",
              "isPercentagePointMetric": true
            },
            {
              "cardId": "top_customer_revenue",
              "label": "Top-10 Customers Revenue",
              "type": "revenue"
            },
            {
              "cardId": "top_customer_share",
              "label": "Top-10 Share of Revenue",
              "type": "percentage",
              "isPercentagePointMetric": true
            }
          ]
        }
      }
    }
  }
}
